<div id="main" class="d-flex flex-column justify-content-center">
  <form [formGroup]="formGroup" novalidate>
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-sm-7 col-lg-6 content-message text-center">
        <app-content-message [icon]="icon" [title]="title" [description]="">
        </app-content-message>

        <div class="w-100 d-flex justify-content-center text-left">
          <div class="w-85">
            <p>
              Tu asesor te contactará para finalizar el proceso. Si tienes
              alguna inquietud comunícate al <strong>6063456</strong> en Bogotá
              o al <strong>018000 523456</strong> en el resto del país
            </p>
          </div>
        </div>

        <div class="h-14-px"></div>

        <div class="w-100 h-110-px d-flex justify-content-center">
          <div class="container-button">
            <div class="container-center-button">
              <app-button
                id="app-button_button-click"
                [cssClass]="'w-100 buttonTextMedium'"
                [mandatory]="true"
                [text]="'Salir'"
                [parentForm]="formGroup"
                (clickEvent)="continue()"
              ></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
